import { render } from "./Order.vue?vue&type=template&id=402d4a1c&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=402d4a1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-402d4a1c"

export default script